import React, { useId } from 'react'
import PropTypes from 'prop-types'

const TestTubeIcon = React.forwardRef(function TestTubeIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 7V19C9 20.6577 10.3423 22 12 22C13.6577 22 15 20.6577 15 19V7H17V19C17 21.7623 14.7623 24 12 24C9.23772 24 7 21.7623 7 19V7H9Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 12C10 11.4477 10.4477 11 11 11H13C13.5523 11 14 11.4477 14 12 14 12.5523 13.5523 13 13 13H11C10.4477 13 10 12.5523 10 12ZM10 17C10 16.4477 10.4477 16 11 16H13C13.5523 16 14 16.4477 14 17 14 17.5523 13.5523 18 13 18H11C10.4477 18 10 17.5523 10 17ZM5 7C5 6.44772 5.44772 6 6 6H18C18.5523 6 19 6.44772 19 7 19 7.55228 18.5523 8 18 8H6C5.44772 8 5 7.55228 5 7ZM12 0C12.5523 0 13 .447715 13 1V2C13 2.55228 12.5523 3 12 3 11.4477 3 11 2.55228 11 2V1C11 .447715 11.4477 0 12 0ZM17.4472.105548C17.9412.352537 18.1414.95321 17.8944 1.44719L16.8944 3.44719C16.6474 3.94117 16.0468 4.14139 15.5528 3.8944 15.0588 3.64741 14.8586 3.04674 15.1056 2.55276L16.1056.552761C16.3526.0587828 16.9532-.141442 17.4472.105548ZM6.55279.105548C7.04677-.141442 7.64744.0587828 7.89443.552761L8.89443 2.55276C9.14142 3.04674 8.9412 3.64741 8.44722 3.8944 7.95324 4.14139 7.35257 3.94117 7.10558 3.44719L6.10558 1.44719C5.85859.95321 6.05881.352537 6.55279.105548Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

TestTubeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

TestTubeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default TestTubeIcon
